export default {
    nav_my_cards: "Mis Tarjetas",
    nav_mini_site: "Mini Sitio",
    nav_email_signature: "Firma de Correo",
}
